import React, { createContext, useState } from 'react';

// Create context
export const GlobalStateContext = createContext();

// Provider component
export const GlobalStateProvider = ({ children }) => {
  const [formData, setFormData] = useState({
    employee_no: '',                // Employee ID
    name: '',                       // Employee Name
    date_of_joining: '',            // Date of Joining
    gender: '',                 // Gender (default to 'male')
    date_of_birth: '',    // Date of Birth (default value)
    email: '',   // Email ID (default value)
    status: '',               // Status (default to 'active')
    confirmation_date: '',          // Confirmation Date
    reporting_manager: '',          // Manager Name
    manager_id: '',                 // Manager ID
    reporting_manager_id: null,     // Relational Employee manager ID
    mobile_number: '',    // Phone No (default value)
    employment_status: '',          // Employment Status
    pan_no: '',                     // PAN Number
    uan_no: '',                     // UAN Number
    bank_account_no: '',            // Bank Account Number
    nationality: '',                // Nationality
    location: '',                   // Location
    designation: '',                // Designation
    department: '',                 // Department
    grade: '',                      // Grade
    attendance_schema: '',          // Attendance Scheme
    level_cost_center: '',          // Cost Center/Level
    branch_name: '',                // Branch Name
    branch_id: null,                // Relational Branch ID
    division: '',                   // Division
    ifsc_code: '',                  // IFSC Code
    aadhaar_number: '',             // Aadhaar Number
    team_head: '',
    ESIno: '',                      // ESI Number
    custom_attributes: {},          // Tenant-configured employee fields
  });

  return (
    <GlobalStateContext.Provider value={{ formData, setFormData }}>
      {children}
    </GlobalStateContext.Provider>
  );
};
